import { Spacer } from '@rmstransactions/components';
import React from 'react';
import { InPageAlertHeaderOverride } from '../AlmostDonePage.style';
import {
  legallyDriveDownloadContent,
  serviceCenterLink,
  downloadDigitalDriverLicenceLink
} from 'utils/helpers/ErrorHandlers/helpers/errorContentDetails';
import { serviceCenterPhoneNumber } from 'utils/shared/shared';
import { checkForWarningsAndErrors } from 'utils/helpers/checkForWarningsAndErrors';
import { ILicenceCategoryLicenceApi } from 'interfaces/api/response/ILicence';
import { useLicenceExpiry} from '../../YourLicence/components/useLicenceExpiry';

interface AlertProps {
  licenceCategory: ILicenceCategoryLicenceApi[];
}

const AlertActiveRefusalSanctionWarning: React.FC<AlertProps> = ({
  licenceCategory,
}) => {
  let isActiveRefusalSanctionWarningPresent = false;
  let isActiveRefusalSanctionWithExpiringLicence = false;
  const expiryDate = useLicenceExpiry(); 

  if (licenceCategory != null) {
    const { warningCodes } = checkForWarningsAndErrors(licenceCategory);

    isActiveRefusalSanctionWarningPresent =
    warningCodes.includes('ACTIVE_REFUSAL_PRESENT') ||
    warningCodes.includes('ACTIVE_SANCTION_EXISTS');

    isActiveRefusalSanctionWithExpiringLicence = 
    warningCodes.includes('DRIVING_LIC_DUE_FOR_EXP') &&
    isActiveRefusalSanctionWarningPresent;

    if (isActiveRefusalSanctionWithExpiringLicence) {
      isActiveRefusalSanctionWarningPresent = false;
    }
  }

  return (
    <>
      {isActiveRefusalSanctionWarningPresent && (
        <Spacer mt={2}>
          <InPageAlertHeaderOverride
            variant='warning'
            title={`Restrictions on your NSW Driver Licence`}
          >
            <div>
              <p>
                Due to restrictions on your licence you are only eligible for an
                Interim Driver Licence and will not receive a new NSW Driver
                Licence card. Your Interim Driver Licence is valid for two months
                from the issue date{' '}
                <b>
                  or until your licence expiry date (whichever comes first).
                </b>
              </p>{' '}
              <Spacer mt={1}>{legallyDriveDownloadContent}</Spacer>{' '}
              <Spacer mt={1} mb={1}>
                <p>
                  Need more information? Call us on {serviceCenterPhoneNumber},
                  or visit a {serviceCenterLink}.
                </p>
              </Spacer>{' '}
            </div>
          </InPageAlertHeaderOverride>
        </Spacer>
      )}
      {isActiveRefusalSanctionWithExpiringLicence && (
        <Spacer mt={2}>
          <InPageAlertHeaderOverride
            variant='warning'
            title={`Restrictions on your NSW Driver Licence`}
          >
            <div>
            <p>
              Due to restrictions on your licence you are only eligible for an
              Interim Driver Licence and will not receive a new NSW Driver Licence card.
              Your Interim Driver Licence is valid for two months from the issue date or
               until {expiryDate}, when your licence expires (check which date comes first).
            </p>
            <Spacer mt={1}>
              To legally drive, you must print and carry your Interim Driver Licence or download
               your {downloadDigitalDriverLicenceLink} via the Service NSW app.
            </Spacer>
            <Spacer mt={1} mb={1}>
            <p>
              Need more information? Call us on {serviceCenterPhoneNumber} , or visit a{' '}
            {serviceCenterLink}.
            </p>
            </Spacer>{' '}
            </div>
          </InPageAlertHeaderOverride>
        </Spacer>
      )}

    </>
  );
};

export default AlertActiveRefusalSanctionWarning;
